/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Name_Form_Firstname_Label1Inputs */

const en_user_name_form_firstname_label1 = /** @type {(inputs: User_Name_Form_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

const de_user_name_form_firstname_label1 = /** @type {(inputs: User_Name_Form_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {User_Name_Form_Firstname_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const user_name_form_firstname_label1 = /** @type {((inputs?: User_Name_Form_Firstname_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Name_Form_Firstname_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_name_form_firstname_label1(inputs)
	return en_user_name_form_firstname_label1(inputs)
});
export { user_name_form_firstname_label1 as "user_name_form_firstName_label" }